export default function ({ store }) {
  if (store.state.menuOpen) {
    store.commit('SET_MENU', false)
  }
}
